export enum PeriodeEnum {
  ThreeMonth = 3,
  SixMonth = 6,
  TwelveMonth = 12
}